module.exports = __webpack_public_path__ + "img/teresaIarocciMavica.58381271.jpg";